import { render } from "./DeleteTeamForm.vue?vue&type=template&id=6314bc06"
import script from "./DeleteTeamForm.vue?vue&type=script&lang=js"
export * from "./DeleteTeamForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__